import { Button, Typography } from 'antd';

const { Text } = Typography;

export default function VolunteerismInformationView({ volunteerismData, onEdit }) {

  const displayData = volunteerismData;
 
  return (
    <>
      {/* <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        <Button
          type="default"
          icon={<EditOutlined />}
          onClick={onEdit}
          style={{ position: 'absolute', top: '24px', right: '24px', borderColor: '#fa541c', color: '#fa541c' }}
        >
        </Button>
      </div> */}
      {/* Display Preferred Volunteer Role(s) */}
      <div style={{ marginBottom: 16 }}>
        <Text strong>Preferred Volunteer Role(s)</Text>
        <div style={{ marginTop: 8 }}>
          {displayData?.preferredRoles &&
          displayData?.preferredRoles?.length > 0 ? (
            <ul>
              {displayData?.preferredRoles?.map((role) => (
                <li>
                  <p key={role.key} style={{ margin: "0", lineHeight: "1.5" }}>
                    {role.value}{" "}
                    {role.value == "Other" && displayData?.otherRole && (
                      <span>({displayData?.otherRole})</span>
                    )}
                  </p>
                </li>
              ))}
            </ul>
          ) : (
            <Text italic>No preferred roles selected.</Text>
          )}
        </div>
      </div>

      {/* Display Reasons for Volunteering */}
      <div>
        <Text strong>Reasons for Volunteering</Text>
        <div style={{ marginTop: 8 }}>
          {displayData?.reasons && displayData?.reasons?.length > 0 ? (
            <ul>
              {displayData?.reasons?.map((reason) => (
                <li>
                  <p
                    key={reason.key}
                    style={{ margin: "0", lineHeight: "1.5" }}
                  >
                    {reason.value}{" "}
                    {reason.value == "Other" && displayData?.otherReason && (
                      <span>({displayData?.otherReason})</span>
                    )}
                  </p>
                </li>
              ))}
            </ul>
          ) : (
            <Text italic>No reasons selected.</Text>
          )}
        </div>
      </div>

      <div style={{ textAlign: "right", marginTop: "10px" }}>
        <Button
          type="primary"
          onClick={onEdit}
          // style={{ backgroundColor: '#fa541c', borderColor: '#fa541c' }}
          className="primary-volunteer-button"
        >
          Edit
        </Button>
      </div>
    </>
  );
};
